/* template */
<template><div class="list-city"><div v-for="(item, index) in (list)" :key="item.index" class="addr"><mpx-view :class='("addr-city addr-base "+(item.type === 2 ? "addr-city-airport" : ""))' @tap.stop="handleClick(item,$event)"><div :class='"addr-logo"'><span>{{item.type === 2 ? '机场' : '城市'}}</span></div><div class="addr-city-name">{{ item.name || item.city_name }}</div><div v-show="(item.id)" class="addr-code">{{ item.id }}</div></mpx-view><div class="addr-airport"><mpx-view v-for="(air, airIndex) in (item[type])" :key="air.airIndex" @tap.stop="handleClick({...item, ...air},$event)" v-show="(airIndex < statusArr[index])" class="addr-base"><div class="addr-logo addr-logo-airport"><span>{{ label }}</span></div><div class="addr-airport-name">{{ air[labelType] }}</div><div v-show="(air.id)" class="addr-code">{{ air.id }}</div></mpx-view></div><mpx-view @tap="changeCollapse(index)" class="show-more" v-if="(item[type].length > LIMIT_SHOW_STATION)">{{ statusArr[index] === LIMIT_SHOW_STATION ? '展开更多车站' : '收起'
        }}<mpx-image :src="(statusArr[index] === LIMIT_SHOW_STATION ? 'https://dpubstatic.udache.com/static/dpubimg/1slb1OdJWmaOxS-6ScrSD.png' : 'https://dpubstatic.udache.com/static/dpubimg/89qPebOI7E6fZFTYRSXxV.png')" class="show-more-arrow"/></mpx-view></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m66d63829"}'>
  .list-city
    padding 0 16px
  .addr
    display flex
    flex-direction column
    align-items flex-start
  .addr-logo
    margin-right 8px
    font-size 10px
    border-radius 4px
    width 38px
    height 36rpx
    display flex
    align-items center
    justify-content center
  .addr-base
    box-sizing border-box
    height 47.5px
    border-bottom 1px solid rgba(0, 0, 0, 0.08)
    display flex
    align-items center
    justify-content flex-start
    width 100%
  .addr-airport
    box-sizing border-box
    padding-left 46px
    width 100%
  .addr-city
    .addr-logo
      color #ffffff
      background #1473FF
    .addr-city-name
      font-family Ping Fang SC
      font-size 14px
      font-weight 600
      color #333333
    &.addr-city-airport
      .addr-city-name
        font-weight 400
  .addr-logo-airport, .addr-city-airport .addr-logo
    color #1473FF
    background #ffffff
    border solid 0.5px #1473FF
    font-weight 400
  .addr-airport-name
    font-family Ping Fang SC
    font-size 14px
    font-weight 400
    color #333333
  .addr-code
    margin-left 8px
    font-family Ping Fang SC
    font-size 14px
    font-weight 400
    color #999999
  .show-more
    font-size 12px
    color #3D3D3D
    margin-top 16.5px
    padding-left 46px
    display flex
    align-items center
    line-height 12px
    padding-bottom 30px
    font-family PingFangSC-Regular
  .show-more-arrow
    width 16px
    height 16px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m66d63829"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./city-search.mpx.js?isComponent&outputPath=components%2Fcity-search66d63829%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./city-search.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcity-search66d63829%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m66d63829"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/city-search66d63829/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
